export class OpenItem {
  almacen: string;
  origen: string;
  ptoEmision: string;
  nroRemito: string;
  fecGen: Date | null = new Date();
  fecARetornar: Date | null= new Date();
  fecSalida: Date | null= new Date();
  cantProrrogas: string | null;
  ultFecProrroga: Date | null= new Date();
  motivo: string | null;
  dock: string | null;
  solicitante: string;
  destino: string;
  transporte: string;
  comentario: string;
  nroTicket: string;
  codDealer: string ;
  codTransp: string;
  patenteTransp: string;
  totCont: number;


  /**
   * Adapted from ReportRemito.ts - see comment there for explanation
   * @param data The data received from HttpClient.
   */
  static transformData(data: any): OpenItem {
    let openItem = new OpenItem();
    openItem.almacen = data.almacen;
    openItem.origen = data.origen;
    openItem.ptoEmision = data.ptoEmision;
    if(data.nroRemito != null)
      openItem.nroRemito = data.nroRemito.toString();
    openItem.fecGen = data.fecGen != null ? new Date(data.fecGen) : null;
    openItem.fecARetornar = data.fecARetornar != null ? new Date(data.fecARetornar) : null;
    openItem.fecSalida = data.fecSalida != null ? new Date(data.fecSalida) : null;
    openItem.cantProrrogas = data.cantProrrogas;
    openItem.ultFecProrroga = data.ultFecProrroga != null ? new Date(data.ultFecProrroga) : null;
    openItem.motivo = data.motivo;
    openItem.dock = data.dock;
    openItem.solicitante = data.nameSolicitante;
    openItem.transporte = data.codTransp;
    openItem.comentario = data.comentario;
    openItem.nroTicket = data.nroTicket;
    openItem.destino = data.codDealer;
    openItem.totCont = data.totCont;

    return openItem;
  }

}


